export enum RackTypeEnum {
    Corner = 'corner',
    Center = 'center',
}